import type { PortalAccessMap } from './portalAccess';
import { normalizeUserRole } from './settingsPermissions';
import type { UserRole } from '../types/crm';

/** Only IT / Management department may open the Admin Hub (portal admin tags do not). */
export function resolveAdminHubActorRole(portalAccess: PortalAccessMap | null): UserRole | null {
  if (!portalAccess?.elevatedDepartment) return null;
  return portalAccess.elevatedDepartment === 'management' ? 'management' : 'it';
}

export function canAccessAdminHub(portalAccess: PortalAccessMap | null): boolean {
  return resolveAdminHubActorRole(portalAccess) != null;
}

/** DEM business config (sequences, integrations, templates) from Admin Hub. */
export function canManageDemConfigInAdminHub(role: UserRole): boolean {
  const normalized = normalizeUserRole(role);
  return normalized === 'it' || normalized === 'management';
}

/** CRM workspace configuration from Admin Hub. */
export function canManageCrmConfigInAdminHub(role: UserRole): boolean {
  return canManageDemConfigInAdminHub(role);
}

/** IT workspace configuration from Admin Hub (separate storage later). */
export function canManageItConfigInAdminHub(role: UserRole): boolean {
  return canManageDemConfigInAdminHub(role);
}

/** Application Form workspace configuration from Admin Hub. */
export function canManageFormsConfigInAdminHub(role: UserRole): boolean {
  return canManageDemConfigInAdminHub(role);
}
